import { Component, OnInit, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PropertyChargeScheduleSummaryModel } from '../../../../core/models/data/property-charge-schedule-summary.model';
import { ChargesService } from '../../../../core/services/charge/charge.service';
import { PropertyChargeScheduleSummaryHeaderComponent } from '../../components/property-charge-schedule-summary-header/property-charge-schedule-summary-header.component';
import { PropertyChargeScheduleSummaryTotalsComponent } from '../../components/property-charge-schedule-summary-totals/property-charge-schedule-summary-totals.component';
import { PropertyChargeListComponent } from '../../components/property-charge-list/property-charge-list.component';
import { AuditEntityType, PropertyChargeListViewLocations } from '../../../../core/enums/base.enums';
import { AuditLogsComponent } from '../../../../parts/audit-logs/audit-logs.component';

type SummaryTab = 'invoices' | 'auditLog';

@Component({
  selector: 'ms-property-charge-schedule-summary-page',
  imports: [CommonModule, PropertyChargeScheduleSummaryHeaderComponent, PropertyChargeScheduleSummaryTotalsComponent, PropertyChargeListComponent, AuditLogsComponent],
  templateUrl: './property-charge-schedule-summary.page.html',
})
export class PropertyChargeScheduleSummaryPage implements OnInit {

  public propertyChargeScheduleSummary = signal<PropertyChargeScheduleSummaryModel | undefined>(undefined);
  public isLoading = signal<boolean>(false);
  public propertyChargeScheduleId: number | undefined;
  public PropertyChargeListViewLocations = PropertyChargeListViewLocations;
  public AuditEntityType = AuditEntityType;

  public activeTab = signal<SummaryTab>('invoices');

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private chargesService: ChargesService
  ) { }

  ngOnInit(): void {
    this.propertyChargeScheduleId = +(this.activatedRoute.snapshot.paramMap.get('propertyChargeScheduleId') ?? NaN) || undefined;

    if (!this.propertyChargeScheduleId) {
      this.router.navigate(['system', '404']);
      return;
    }

    this.loadPropertyChargeScheduleSummary();
  }

  public setActiveTab(tab: SummaryTab): void {
    this.activeTab.set(tab);
  }

  private async loadPropertyChargeScheduleSummary(): Promise<void> {
    this.isLoading.set(true);
    this.propertyChargeScheduleSummary.set(undefined);

    try {
      let response = await this.chargesService.getPropertyChargeScheduleSummaryById(this.propertyChargeScheduleId!);

      if (response.success === true && response.data) {
        this.propertyChargeScheduleSummary.set(response.data);
      } else {
        this.router.navigate(['system', '404']);
        return;
      }
    } catch (error) {
      console.error('Error loading property charge schedule summary:', error);
      this.router.navigate(['system', '404']);
      return;
    } finally {
      this.isLoading.set(false);
    }
  }
}
